import React from 'react';
import {observer} from 'mobx-react-lite';
import {SingleCountrySettingsType} from 'src/api/config/admin/getCountries';
import { CountrySettingsHeader, CountrySettingsWrapper } from 'src/components/AdminCountryDefaults/CountrySettings.style';

function stopPropagation(e: any): void {
    e.stopPropagation();
}

const getKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>;

type CountrySettingsPropsType = {
    settings: SingleCountrySettingsType
    onCountryClick: (id: string, name: string, service: string, checked: boolean) => Promise<void>
}

export const CountrySettings = observer(({ settings, onCountryClick }: CountrySettingsPropsType) => {

    return (
        <CountrySettingsWrapper className='country-settings'>
            <CountrySettingsHeader>
                { settings.name }
            </CountrySettingsHeader>

            <div className='form'>
                {
                    getKeys(settings.services).map(
                        (k) => (
                            <div className='element checkbox btn' key={`${settings.id}+${k}`}>
                                <label onClick={ stopPropagation }>
                                    <input
                                        type='checkbox'
                                        name='active'
                                        checked={ settings.services[k] }
                                        onChange={ (e) => onCountryClick(
                                            settings.id,
                                            settings.name,
                                            k,
                                            e.target.checked
                                        ) }
                                    />
                                    <span>{ k }</span>
                                </label>
                            </div>
                        )
                    )
                }
            </div>
        </CountrySettingsWrapper>
    );
});
